import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/FadeIn';
import { BookOpen, Headphones, Download } from 'lucide-react';
export function ResurseGratuitePage() {
  return <>
      <SharedNavbar data-id="element-952" />
      <main className="flex-grow" data-id="element-953">
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 bg-ivory overflow-hidden" data-id="element-954">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-955">
            <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-956"></div>
            <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-957"></div>
            <div className="absolute top-10 left-0 text-[15vw] font-serif font-bold text-forest/[0.03] whitespace-nowrap select-none leading-none" data-id="element-958">
              RESURSE
            </div>
          </div>

          <div className="max-w-[800px] mx-auto px-6 md:px-8 text-center relative z-10" data-id="element-959">
            <FadeIn data-id="element-960">
              <div className="inline-block border border-gold/40 rounded-full px-5 py-2 mb-6 bg-white/50 backdrop-blur-sm" data-id="element-961">
                <span className="font-display text-sm font-medium tracking-wider text-forest uppercase" data-id="element-962">
                  Resurse Gratuite
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-963">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-964">
                Cadoul meu pentru tine
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-965">
              <p className="text-[19px] text-charcoal/80 mb-2 leading-relaxed" data-id="element-966">
                Două instrumente blânde care te însoțesc în drumul către tine:
                un ghid de prim ajutor emoțional și o meditație de împământare.
              </p>
            </FadeIn>
          </div>
        </section>

        {/* RESOURCES — small round photo cards */}
        <section className="py-12 md:py-20 bg-white" data-id="element-967">
          <div className="max-w-[1000px] mx-auto px-6 md:px-8" data-id="element-968">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-969">
              {/* eBook */}
              <FadeIn data-id="element-970">
                <div className="bg-ivory border border-forest/10 rounded-[28px] p-8 md:p-10 h-full flex flex-col items-center text-center hover:shadow-xl transition-all duration-500 hover:-translate-y-1" data-id="element-971">
                  {/* Small round photo with gold ring + icon badge */}
                  <div className="relative mb-6" data-id="element-972">
                    <div className="w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-gold/40 shadow-md" data-id="element-973">
                      <img src="https://cdn.magicpatterns.com/uploads/evDwG7z43w5PHEtDALy7Je/ghid_prim_ajutor_square.jpg" alt="Ghidul de Prim Ajutor Emoțional" className="w-full h-full object-cover" data-id="element-974" />
                    </div>
                    <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-forest flex items-center justify-center shadow-md" data-id="element-975">
                      <BookOpen className="w-5 h-5 text-ivory" data-id="element-976" />
                    </div>
                  </div>

                  <h3 className="text-2xl font-serif font-medium text-forest mb-4 leading-tight" data-id="element-977">
                    Ghidul de Prim Ajutor Emoțional
                  </h3>

                  <p className="text-[18px] text-charcoal/75 leading-relaxed mb-8 flex-grow" data-id="element-978">
                    Un eBook scurt și practic cu 5 tehnici rapide pe care le
                    poți folosi atunci când simți că anxietatea sau stresul
                    preiau controlul.
                  </p>

                  <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-forest text-ivory font-display text-[15px] font-medium hover:bg-forest-dark transition-colors no-underline gap-2" data-id="element-979">
                    <Download className="w-4 h-4" data-id="element-980" />
                    Descarcă PDF
                  </a>
                </div>
              </FadeIn>

              {/* Audio */}
              <FadeIn delay={0.1} data-id="element-981">
                <div className="bg-ivory border border-forest/10 rounded-[28px] p-8 md:p-10 h-full flex flex-col items-center text-center hover:shadow-xl transition-all duration-500 hover:-translate-y-1" data-id="element-982">
                  {/* Small round photo with gold ring + icon badge */}
                  <div className="relative mb-6" data-id="element-983">
                    <div className="w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-gold/40 shadow-md" data-id="element-984">
                      <img src="https://cdn.magicpatterns.com/uploads/sijPPqRzFcNSfpb6eHG5Ta/meditatie_impamanare_square.jpg" alt="Meditație pentru Împământare" className="w-full h-full object-cover" data-id="element-985" />
                    </div>
                    <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-forest flex items-center justify-center shadow-md" data-id="element-986">
                      <Headphones className="w-5 h-5 text-ivory" data-id="element-987" />
                    </div>
                  </div>

                  <h3 className="text-2xl font-serif font-medium text-forest mb-4 leading-tight" data-id="element-988">
                    Meditație pentru Împământare
                  </h3>

                  <p className="text-[18px] text-charcoal/75 leading-relaxed mb-8 flex-grow" data-id="element-989">
                    Un audio ghidat de 10 minute pentru momentele în care te
                    simți deconectată de corpul tău și ai nevoie să revii în
                    prezent.
                  </p>

                  <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-forest text-ivory font-display text-[15px] font-medium hover:bg-forest-dark transition-colors no-underline gap-2" data-id="element-990">
                    <Headphones className="w-4 h-4" data-id="element-991" />
                    Ascultă Audio
                  </a>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-992" />
    </>;
}